import demoStageJson from '../examples/stage-state.v1.valid.json'
import type { StageStateV1 } from './index'

export const DEMO_STAGE_STATE = demoStageJson as StageStateV1
